import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { UrlContext } from "../../../contexts/UrlContext";
import DeclineProfile from "./declineProfile";
import Assessments from "./assessments";
import DisplayTranscript from "./displayTranscript";
import ViewTranscriptFile from "./viewTranscriptFile";
import { DayPilot } from "@daypilot/daypilot-lite-react";
import DownloadMeetingVideo from "./downloadMeetingVideo";
import CallDetails from "./callDetails";
import MeetingTranscript from "./MeetingTranscript";
import MeetingVideo from "./MeetingVideo";
import CallRequest from "./CallRequest";

export default function SharePorfileRow({
  data,
  index,
  proj_id,
  expert_id,
  projectType,
  setShowRow,
  setShowDetails,
  setCurrentSlide,
  isCalenderOpen,
  setIsCalendarOpen,
  isChanged,
  setIsChanged,
  setChangedValue,
  setSingleExpert,
  setAllExpert,
  fromRequest,
  setFromRequest,
  clickingOnProfile,
  profilesList,
  markProfilesAsCallRequested,
  embeddedWizardMode = false,
  embeddedWizeredMode = false,
}) {
  const isDownloaded = "/pictures/";
  const { API_URL } = useContext(UrlContext);
  const [isAccepted, setIsAccepted] = useState(data.isSelected);
  const [isDeclined, setIsDeclined] = useState(data.isDeclined);
  const [showDecline, setShowDecline] = useState(false);
  const [isCallScheduled, setIsCallScheduled] = useState(data.isCallScheduled);
  const [isCallConducted, setIsCallConducted] = useState(data.isCallEnded);
  const [isCallRequested, setIsCallRequested] = useState(data.isCallRequested);
  const [isFavourite, setIsFavourite] = useState(data.isFavourite);
  const [hasTranscript, setHasTanscript] = useState(data.isTranscriptAvailable);
  const [openAssessment, setOpenAssessment] = useState(false);
  const [clientAssessmentData, setClientAssessmentData] = useState(null);
  const [isGoodTotal, setIsGoodTotal] = useState(0);
  const [isNeutralTotal, setIsNeutralTotal] = useState(0);
  const [isBadTotal, setIsBadTotal] = useState(0);
  const [isViewTranscript, setIsViewTranscript] = useState(false);
  const [tanscriptConter, setTranscriptCounter] = useState(0);
  const [hoveringIndex, setHoverIndex] = useState(null);
  const [expertEvents, setExpertEvents] = useState([]);
  const [onViewTranscript, setOnViewTranscript] = useState(false);
  const [transcript, setTranscript] = useState(null);
  const [isTweak, setIsTweak] = useState(false);
  const [isMeetingVideo, setIsMeetingVideo] = useState(false);
  const [isRecordingUrl, setIsRecordingUrl] = useState(false);
  const [viewCallDetails, setViewCallDetails] = useState(false);

  const [transcripts, setTranscripts] = useState(data.transcript || []);
  const [meetingID, setMeetingID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isExpertCalendarOpen, setIsExpertCalendarOpen] = useState(false);

  useEffect(() => {
    setIsCallRequested(data.isCallRequested);
  }, [data.isCallRequested]);

  const eventToString = (selectedEvent) => {
    const selectedTimeSlot = {
      weekday: new Intl.DateTimeFormat("en-GB", { weekday: "short" }).format(
        new Date(selectedEvent.startTime)
      ),
      day: new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(
        new Date(selectedEvent.startTime)
      ),
      month: new Intl.DateTimeFormat("en-GB", { month: "short" }).format(
        new Date(selectedEvent.startTime)
      ),
      year: new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(
        new Date(selectedEvent.startTime)
      ),
      startTime: new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date(selectedEvent.startTime)),
      endTime: new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date(selectedEvent.endTime)),
    };
    return `${selectedTimeSlot.weekday}, ${selectedTimeSlot.day} ${selectedTimeSlot.month} ${selectedTimeSlot.year} ${selectedTimeSlot.startTime} - ${selectedTimeSlot.endTime} (${selectedEvent.timezone})`;
  };

  // API to add favourite
  const addFavourite = async () => {
    const requestBody = {
      projectID: proj_id,
      expertID: data.expertID,
    };
    try {
      let modifiedUrl = "add-to-favourite";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setIsFavourite(true);
      } else {
        console.error("Failed to add favourite!");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // API to remove from favourite
  const removeFavourite = async () => {
    const requestBody = {
      projectID: proj_id,
      expertID: data.expertID,
    };
    try {
      let modifiedUrl = "remove-from-favourite";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setIsFavourite(false);
      } else {
        console.error("Failed to add favourite!");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // API for selecting a consultant
  const selectConsultantForCall = async () => {
    const requestBody = {
      projectID: data.projectID,
      expertID: data.expertID,
      client: true,
    };
    try {
      let modifiedUrl = "select-consultant-for-call";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setIsAccepted(true);
        setChangedValue(true);
        setIsChanged(!isChanged);
        Swal.fire({
          title: "Shortlisted!",
          text: "Profile has been added to short-list!",
          icon: "success",
          // confirmButtonText: "OK",
        });
      } else {
        console.error("Failed to add selected consultant");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // API for remove expert from selected list
  const unselectConsultant = async () => {
    Swal.fire({
      title: "Unselect this consultant?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Unselect!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const requestBody = {
          projectID: data.projectID,
          expertID: data.expertID,
          client: true,
        };

        try {
          let modifiedUrl = "unselect-consultant-for-call";
          const response = await fetch(`${API_URL}${modifiedUrl}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseData = await response.json();
          if (responseData.status === "success") {
            setIsAccepted(false);
            setChangedValue(false);
            setIsChanged(!isChanged);
            Swal.fire({
              title: "Unselected!",
              text: "Consultant has been unselected.",
              icon: "success",
            });
          } else {
            console.error("Failed to unselect the consultant");
            // setLoading(false);
            Swal.fire({
              title: "Error!",
              text: responseData.text,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error while calling the backend API:", error);
          // setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "Unexpected error!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // API for creating link
  const addToExistingLink = async () => {
    Swal.fire({
      title: "Reactive this consultant?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Reactivate!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const expertIds = [data.expertID];
        const requestBody = {
          projectID: data.projectID,
          expertList: expertIds,
          hasLanguage: data.hasLanguage,
          hasRegion: data.hasRegion,
          hasMatching: data.hasMatching,
          hasScreening: data.hasScreening,
          hasEducation: data.hasEducation,
          hasName: data.hasName,
          hasLocation: data.hasLocation,
        };

        try {
          let modifiedUrl = "add-to-existing-link";
          const response = await fetch(`${API_URL}${modifiedUrl}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseData = await response.json();
          if (responseData.status === "success") {
            setIsDeclined(false);
            Swal.fire({
              title: "Reactivated!",
              text: "Consultant has be reactivated!",
              icon: "success",
            });
          } else {
            console.error("Failed to create link!");
            // setLoading(false);
            Swal.fire({
              title: "Error!",
              text: responseData.text,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error while calling the backend API:", error);
          // setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "Unexpected error!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const handleClick = () => {
    setCurrentSlide(index);
    setShowDetails(true);
    clickingOnProfile(data.expertID, 'Client opened profile');
  };

  // API for fetching client assessments
  const getClientAssessment = async () => {
    const requestBody = {
      projectID: proj_id,
      expertID: data.expertID,
    };
    try {
      let modifiedUrl = "get-client-assessments";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setClientAssessmentData(responseData.clientAssessmentData);
      } else {
        console.error("Failed to fetch assessment data!");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // API for fetching meeting timeslots
  const getMeetingSlots = async () => {
    const requestBody = {
      projectID: proj_id,
      expertID: data.expertID,
    };
    try {
      let modifiedUrl = "get-expert-meeting-time-slot";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        const formattedEvents = responseData.eventData.map((event) => ({
          eventID: event.eventID,
          expertID: event.expertID,
          projectID: event.projectID,
          timezone: event.timezone,
          startTime: new DayPilot.Date(event.startTime),
          endTime: new DayPilot.Date(event.endTime),
          start: new DayPilot.Date(event.startTime),
          end: new DayPilot.Date(event.endTime),
          text: eventToString(event),
        }));
        setExpertEvents(formattedEvents);
      } else {
        console.error("Failed to add selected slot");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  useEffect(() => {
    getClientAssessment();
    getMeetingSlots();
  }, []);

  useEffect(() => {
    if (clientAssessmentData) {
      const goodAssessments = clientAssessmentData.filter(
        (assessment) => assessment.isGood === true
      );
      const badAssessments = clientAssessmentData.filter(
        (assessment) => assessment.isBad === true
      );
      const neutralAssessments = clientAssessmentData.filter(
        (assessment) => assessment.isNeutral === true
      );
      setIsGoodTotal(goodAssessments.length);
      setIsBadTotal(badAssessments.length);
      setIsNeutralTotal(neutralAssessments.length);
    }
  }, [clientAssessmentData]);

  const getMeetingID = async () => {
    try {
      const authToken = localStorage.getItem("accesstoken");

      const response = await fetch(`${API_URL}get-meeting-ID`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accessToken: authToken,
          projectID: proj_id,
          expertID: expert_id,
        }),
      });

      const responseData = await response.json();

      if (responseData.status === "success") {
        setMeetingID(responseData.meetingID || null);
        return responseData.meetingID || null;
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  const fetchTranscript = async () => {
    try {
      const resolvedMeetingID = await getMeetingID();

      if (!resolvedMeetingID) {
        setTranscripts([]);
        return;
      }

      const authToken = localStorage.getItem("accesstoken");

      const response = await fetch(`${API_URL}fetch-teams-meeting-transcript`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accessToken: authToken,
          meetingID: resolvedMeetingID,
        }),
      });

      const responseData = await response.json();

      if (responseData.status === "success") {
        const transcriptList = responseData.transcripts || [];
        setTranscripts(transcriptList);
      } else {
        setTranscripts([]);
      }
    } catch (error) {
      setTranscripts([]);
    }
  };

  const generateRecordingLink = async () => {
    try {
      const resolvedMeetingID = await getMeetingID();

      if (!resolvedMeetingID) {
        return;
      }

      const res = await fetch(`${API_URL}get-meeting-video-recording`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          meetingID: resolvedMeetingID,
        }),
      });

      const data = await res.json();

      if (data.status === "success") {
        setIsRecordingUrl(true);
      }
    } catch (error) {
      setIsRecordingUrl(false);
    }
  };

  const getTranscriptRecording = async () => {
    try {
      setLoading(true);

      if (data.transcript) {
        await generateRecordingLink();
      } else {
        await fetchTranscript();
        await generateRecordingLink();
      }
    } catch {
      console.log('trancript fetch function is not working');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTranscriptRecording();
  }, [proj_id, expert_id]);

  // API for fetching meeting timeslots
  const removeRequestForCall = async () => {
    const requestBody = {
      projectID: proj_id,
      expertID: data.expertID,
      client: true,
    };
    try {
      let modifiedUrl = "remove-request-for-call";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        markProfilesAsCallRequested([data.expertID], false);
        Swal.fire({
          title: "Request removed!",
          text: "Your call request has been removed!",
          icon: "success",
          confirmButtonText: "OK",
          timer: 5000,
          timerProgressBar: true,
        });
      } else {
        console.error("Failed to add selected slot");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  const useEmbeddedWizardMode = embeddedWizardMode || embeddedWizeredMode;
  const mobileContentPaddingClass = useEmbeddedWizardMode ? "px-3 py-3" : "px-4 py-3";
  const mobileHeaderTopPaddingClass = useEmbeddedWizardMode ? "pt-8" : "pt-10";
  const mobileAvatarClass = useEmbeddedWizardMode ? "h-12 w-12" : "h-16 w-16";
  const mobileTextClass = useEmbeddedWizardMode ? "text-[12px]" : "text-[13px]";

  const splitExperienceLines = (html = "") =>
    String(html || "")
      .split(/<br\s*\/?>/i)
      .map((line) => line.trim())
      .filter(Boolean);

  const experienceLines = splitExperienceLines(data.expertExperienceText);

  const fallbackProfilePicture =
    "https://images.expertpowerhouse.com/pictures/dummy.png";

  const profilePictureUrl = data.expertProfilePicture
    ? data.expertProfilePicture.includes(isDownloaded)
      ? `https://images.expertpowerhouse.com${data.expertProfilePicture}`
      : data.expertProfilePicture
    : fallbackProfilePicture;

  return (
    <>
      <style>{`
        .share-profile-rich-summary {
          min-width: 0;
          display: block !important;
          overflow: hidden !important;
          text-overflow: ellipsis;
          white-space: normal !important;
          word-break: break-word;
          line-height: 1.15rem !important;
          max-height: 3.45rem !important;
        }

        .share-profile-rich-summary *,
        .share-profile-rich-summary p,
        .share-profile-rich-summary div,
        .share-profile-rich-summary span,
        .share-profile-rich-summary ul,
        .share-profile-rich-summary ol,
        .share-profile-rich-summary li {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          line-height: inherit !important;
          white-space: normal !important;
          word-break: break-word !important;
        }

        .share-profile-rich-summary ul,
        .share-profile-rich-summary ol {
          padding-left: 1rem !important;
          list-style-position: outside !important;
        }

        .share-profile-rich-summary ul {
          list-style-type: disc !important;
        }

        .share-profile-rich-summary ol {
          list-style-type: decimal !important;
        }

        .share-profile-rich-summary li {
          display: list-item !important;
        }

        .share-profile-rich-experience {
          min-width: 0;
          overflow: hidden !important;
          line-height: 1.18rem !important;
          max-height: 3.54rem !important;
        }

        .share-profile-experience-line {
          min-width: 0;
          display: block !important;
          width: 100%;
          margin: 0 !important;
          padding: 0 !important;
          line-height: 1.18rem !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
        }

        .share-profile-experience-line *,
        .share-profile-experience-line p,
        .share-profile-experience-line div,
        .share-profile-experience-line span,
        .share-profile-experience-line strong,
        .share-profile-experience-line b,
        .share-profile-experience-line em,
        .share-profile-experience-line i {
          display: inline !important;
          margin: 0 !important;
          padding: 0 !important;
          line-height: inherit !important;
          white-space: nowrap !important;
        }

        .share-profile-action-stack button {
          min-height: 30px;
          border-radius: 0.75rem !important;
          border-color: rgb(226 232 240) !important;
          background: rgb(248 250 252) !important;
          color: #365561 !important;
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06) !important;
        }

        .share-profile-action-stack button:hover {
          background: #365561 !important;
          border-color: #365561 !important;
          color: white !important;
          box-shadow: 0 10px 24px rgba(54, 85, 97, 0.22) !important;
        }

        .share-profile-status-pills button {
          margin: 0 !important;
          border-radius: 9999px !important;
          padding: 0.25rem 0.65rem !important;
          font-size: 11px !important;
          line-height: 1rem !important;
          font-weight: 700 !important;
          letter-spacing: 0.01em;
          box-shadow: none !important;
        }

        .share-profile-status-pills .status-pill-conducted {
          background: #365561 !important;
          color: #ffffff !important;
          border: 1px solid rgba(54, 85, 97, 0.4) !important;
        }

        .share-profile-status-pills .status-pill-follow-up {
          background: rgb(243 244 246) !important;
          color: rgb(31 41 55) !important;
          border: 1px solid rgb(209 213 219) !important;
        }

        .share-profile-status-pills .status-pill-scheduled {
          background: rgb(254 249 195) !important;
          color: rgb(133 77 14) !important;
          border: 1px solid rgb(254 240 138) !important;
        }

        .share-profile-status-pills .status-pill-requested {
          background: rgba(144, 230, 252, 0.3) !important;
          color: #0B4F63 !important;
          border: 1px solid rgba(144, 230, 252, 0.5) !important;
        }

        .share-profile-status-pills .status-pill-shortlisted {
          background: rgba(3, 192, 74, 0.2) !important;
          color: #036325 !important;
          border: 1px solid rgba(3, 192, 74, 0.4) !important;
        }

        .share-profile-action-stack span,
        .share-profile-status-pills span {
          z-index: 9999 !important;
        }

        .share-profile-position-one-line {
          min-width: 0;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        @media (min-width: 768px) {
          .share-profile-rich-summary {
            line-height: 17px !important;
            height: 102px !important;
            max-height: 102px !important;
            overflow: hidden !important;
          }

          .share-profile-rich-experience {
            line-height: 17px !important;
            max-height: 51px !important;
            min-height: 51px !important;
            max-height: 51px !important;
          }

          .share-profile-experience-line {
            line-height: 17px !important;
          }

          .share-profile-experience-line *,
          .share-profile-experience-line p,
          .share-profile-experience-line div,
          .share-profile-experience-line span,
          .share-profile-experience-line strong,
          .share-profile-experience-line b,
          .share-profile-experience-line em,
          .share-profile-experience-line i {
            line-height: 17px !important;
          }
        }
      `}</style>

      <div
        className={`
          relative mb-3 grid w-full min-w-0 cursor-pointer grid-cols-1 overflow-visible rounded-2xl border border-slate-200 bg-white
          transition-all duration-200 ease-in-out
          md:max-w-[calc(100%-20px)] md:grid-cols-[110px_minmax(0,1fr)] md:overflow-visible md:rounded-xl
          md:!border-0 md:!border-transparent md:!outline-none md:!ring-0
          ${isDeclined ? "opacity-50" : "opacity-100"}
          ${
            hoveringIndex === index
              ? "shadow-[0_14px_34px_rgba(54,85,97,0.18)] md:scale-[1.02] md:shadow-[1px_0px_15px_#365561]"
              : "shadow-[0_10px_28px_rgba(15,23,42,0.08)] md:shadow-[0_0_10px_#bab6b6]"
          }
        `}
        onClick={() => handleClick()}
        onMouseEnter={() => setHoverIndex(index)}
        onMouseLeave={() => setHoverIndex(null)}
      >
        <img
          src={profilePictureUrl}
          alt=""
          className="hidden h-full min-h-[176px] shrink-0 rounded-l-xl bg-[#365561] object-cover md:block"
          style={{
            flex: "0 0 110px",
            width: "110px",
            minWidth: "110px",
            maxWidth: "110px",
          }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = fallbackProfilePicture;
          }}
        />
        
        <div className={["min-w-0 flex-1 md:mt-0 md:mb-0 md:px-0 md:py-0", mobileContentPaddingClass].join(" ")}>
          <div className="flex min-w-0 flex-col md:ml-2.5">
            <div className={["relative grid min-w-0 grid-cols-1 gap-3 pr-0 md:mt-1 md:grid-cols-[minmax(0,1fr)_auto] md:items-start md:gap-3 md:pt-0", mobileHeaderTopPaddingClass].join(" ")}>
              <div className="share-profile-status-pills hidden min-w-0 flex-wrap items-center gap-2 pr-28 md:flex md:pr-2">
                {data.hasName ? (
                  <p className="min-w-0 truncate text-[16px] font-semibold text-slate-900 md:text-[18px]">
                    {projectType === "exp" ? "EPH_EXP_" : "EPH_CON_"}
                    {data.expertDigitalID} ({data.expertName})
                  </p>
                ) : (
                  <p className="min-w-0 truncate text-[16px] font-semibold text-slate-900 md:text-[18px]">
                    {projectType === "exp" ? "EPH_EXP_" : "EPH_CON_"}
                    {data.expertDigitalID}
                  </p>
                )}

                {isCallConducted ? (
                  <>
                    <div>
                      <button
                        className="
                          rounded-full px-2 py-0.5 ml-2
                          bg-[#365561] text-white text-[12px] font-medium
                          ring-1 ring-[#365561]/40
                          shadow-[0_6px_14px_rgba(54,85,97,0.35)]
                          cursor-pointer focus:outline-none
                        "
                      >
                        Call conducted
                      </button>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentSlide(index);
                          setIsExpertCalendarOpen(true);
                          clickingOnProfile(data.expertID, 'Client clicked on follow-up call');
                        }}
                        className="
                          group relative rounded-full px-2 py-0.5 ml-2
                          bg-gray-100 text-gray-800 text-[12px] font-medium
                          ring-1 ring-gray-300
                          shadow-[0_6px_14px_rgba(54,85,97,0.25)]
                          cursor-pointer focus:outline-none
                        "
                      >
                        Follow-up?
                        <span
                          className="
                            absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                            hidden group-hover:flex
                            items-center justify-center
                            bg-[#365561] text-white text-sm px-3 py-1 rounded
                            whitespace-nowrap z-10
                          "
                        >
                          Follow up call
                          <span
                            className="
                              absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                              w-2 h-2 bg-[#365561] rotate-45
                            "
                          />
                        </span>
                      </button>
                    </div>
                  </>
                ) : isCallScheduled ? (
                  <>
                    <div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentSlide(index);
                          setViewCallDetails(true);
                          clickingOnProfile(data.expertID, 'Client viewed Teams call joining details');
                        }}
                        className="
                          group relative ml-2 rounded-full px-2 py-0.5
                          bg-yellow-100 text-yellow-800 text-[12px] font-medium
                          ring-1 ring-yellow-200
                          shadow-[0_6px_14px_rgba(234,179,8,0.25)]
                          focus:outline-none
                        "
                      >
                        <span
                          className="
                            absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                            hidden group-hover:flex
                            items-center justify-center
                            bg-[#365561] text-white text-sm px-3 py-1 rounded
                            whitespace-nowrap z-10
                          "
                        >
                          View Joining Details
                          <span
                            className="
                              absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                              w-2 h-2 bg-[#365561] rotate-45
                            "
                          />
                        </span>
                        Call scheduled
                      </button>
                    </div>
                  </>
                ) : isCallRequested ? (
                  <>
                    <div>
                      <button
                        className="
                          ml-2 mt-[3%] rounded-full px-2 py-0.5
                          bg-[#90E6FC]/30 text-[#0B4F63] text-[12px] font-medium
                          ring-1 ring-[#90E6FC]/50
                          shadow-[0_6px_14px_rgba(144,230,252,0.4)]
                          cursor-pointer focus:outline-none
                        "
                      >
                        Call requested
                      </button>
                    </div>
                  </>
                ) : (
                  isAccepted && (
                    <div>
                      <button
                        className="
                          ml-2 mt-[3%] rounded-full px-2 py-0.5
                          bg-[#03C04A]/20 text-[#036325] text-[12px] font-medium
                          ring-1 ring-[#03C04A]/40
                          shadow-[0_6px_14px_rgba(3,192,74,0.35)]
                          cursor-pointer focus:outline-none
                        "
                      >
                        Shortlisted
                      </button>
                    </div>
                  )
                )}
              </div>
              <div className="share-profile-action-stack absolute right-0 top-0 flex max-w-[62%] flex-wrap items-center justify-end gap-1 text-[#365561] text-[14px] md:static md:mr-[10px] md:max-w-none md:flex-wrap md:p-0.5">
                {!isDeclined ? (
                  <>
                    {loading && (<i class="fa-solid fa-spinner fa-spin"></i>)}
                    {transcripts.length > 0 && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentSlide(index);
                          setIsViewTranscript(true);
                          clickingOnProfile(data.expertID, 'Client clicked on view meeting transcript');
                        }}
                        className="
                          group relative cursor-pointer focus:outline-none
                          px-2 py-1.5 rounded-lg
                          bg-gray-50 font-medium
                          border border-gray-300
                          hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                          hover:!border-[#365561]
                        "
                      >
                        <div className="flex flex-row items-center relative h-[13px]">
                          <i className="fa-solid fa-file-word"></i>
                          <p className="absolute ml-[12px] -mt-[5px] text-[10px]">
                            {transcripts.length}
                          </p>
                        </div>

                        <span
                          className="
                            absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                            hidden group-hover:flex
                            items-center justify-center
                            bg-[#365561] text-white text-sm px-3 py-1 rounded
                            whitespace-nowrap z-10
                          "
                        >
                          View transcript
                          <span
                            className="
                              absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                              w-2 h-2 bg-[#365561] rotate-45
                            "
                          />
                        </span>
                      </button>
                    )}
                    {isRecordingUrl && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentSlide(index);
                          setIsMeetingVideo(true);
                          clickingOnProfile(data.expertID, 'Client clicked on download meeting video');
                        }}
                        className="
                          group relative cursor-pointer focus:outline-none
                          px-2 py-1.5 rounded-lg
                          bg-gray-50 font-medium
                          border border-gray-300
                          hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                          hover:!border-[#365561]
                        "
                      >
                        <div className="flex flex-row items-center relative h-[13px]">
                          <i class="fa-solid fa-file-video"></i>
                          <p className="absolute ml-[12px] -mt-[5px] text-[10px]">
                            {1}
                          </p>
                        </div>

                        <span
                          className="
                            absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                            hidden group-hover:flex 
                            items-center justify-center
                            bg-[#365561] text-white text-sm px-3 py-1 rounded
                            whitespace-nowrap z-10
                          "
                        >
                          Download meeting video
                          <span
                            className="
                              absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                              w-2 h-2 bg-[#365561] rotate-45
                            "
                          />
                        </span>
                      </button>
                    )}
                    {isCallConducted ||
                      (isCallScheduled && (
                        <>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setCurrentSlide(index);
                              setViewCallDetails(true);
                              clickingOnProfile(data.expertID, 'Client viewed Teams call joining details');
                            }}
                            className="
                            group relative cursor-pointer focus:outline-none
                            px-2 py-1.5 rounded-lg
                            bg-gray-50 font-medium
                            border border-gray-300
                            hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                            hover:!border-[#365561]
                          "
                          >
                            <div className="flex flex-row items-center relative h-[13px]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width="20"
                                height="20"
                                viewBox="0 0 55 55"
                                fill="currentcolor"
                              >
                                <path d="M 27.5 5 C 24.08 5 21.269531 7.64 21.019531 11 L 24 11 C 26.76 11 29 13.24 29 16 L 29 17.820312 C 31.87 17.150312 34 14.57 34 11.5 C 34 7.91 31.09 5 27.5 5 z M 42.5 9 A 4.5 4.5 0 0 0 42.5 18 A 4.5 4.5 0 0 0 42.5 9 z M 6 13 C 4.346 13 3 14.346 3 16 L 3 34 C 3 35.654 4.346 37 6 37 L 24 37 C 25.654 37 27 35.654 27 34 L 27 16 C 27 14.346 25.654 13 24 13 L 6 13 z M 10 19 L 20 19 L 20 21 L 16 21 L 16 31 L 14 31 L 14 21 L 10 21 L 10 19 z M 29 21 L 29 34 C 29 36.76 26.76 39 24 39 L 18.199219 39 C 18.599219 40.96 19.569688 42.710313 20.929688 44.070312 C 22.739688 45.880312 25.24 47 28 47 C 33.52 47 38 42.52 38 37 L 38 21 L 29 21 z M 40 21 L 40 37 C 40 37.82 39.919531 38.620625 39.769531 39.390625 C 40.599531 39.780625 41.52 40 42.5 40 C 46.09 40 49 37.09 49 33.5 L 49 21 L 40 21 z"></path>
                              </svg>
                            </div>

                            <span
                              className="
                              absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                              hidden group-hover:flex
                              items-center justify-center
                              bg-[#365561] text-white text-sm px-3 py-1 rounded
                              whitespace-nowrap z-10
                            "
                            >
                              View Joining Details
                              <span
                                className="
                                absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                                w-2 h-2 bg-[#365561] rotate-45
                              "
                              />
                            </span>
                          </button>
                        </>
                      ))}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setCurrentSlide(index);
                        setOpenAssessment(true);
                        clickingOnProfile(data.expertID, 'Client clicked on team assessments');
                      }}
                      className="
                        group relative cursor-pointer focus:outline-none
                        px-2 py-1.5 rounded-lg
                        bg-gray-50 font-medium
                        border border-gray-300
                        hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                        hover:!border-[#365561]
                      "
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          height: "13px",
                        }}
                      >
                        <div
                          className="tooltip-shareProfile"
                          style={{ display: "flex", flexDirection: "row" }}
                        >
                          {isGoodTotal > 0 ? (
                            <i
                              class="fa-regular fa-face-smile"
                              style={{ color: "green" }}
                            ></i>
                          ) : (
                            <i class="fa-regular fa-face-smile"></i>
                          )}
                          <p
                            style={{
                              position: "absolute",
                              marginLeft: "15px",
                              marginTop: "-5px",
                              fontSize: "10px",
                            }}
                          >
                            {isGoodTotal}
                          </p>
                        </div>
                        <div
                          className="tooltip-shareProfile"
                          style={{
                            marginLeft: "15px",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          {isNeutralTotal > 0 ? (
                            <i
                              class="fa-regular fa-face-meh"
                              style={{ color: "gold" }}
                            ></i>
                          ) : (
                            <i class="fa-regular fa-face-meh"></i>
                          )}
                          <p
                            style={{
                              position: "absolute",
                              marginLeft: "15px",
                              marginTop: "-5px",
                              fontSize: "10px",
                            }}
                          >
                            {isNeutralTotal}
                          </p>
                        </div>
                        <div
                          className="tooltip-shareProfile"
                          style={{
                            marginLeft: "15px",
                            marginRight: "5px",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          {isBadTotal > 0 ? (
                            <i
                              class="fa-regular fa-face-frown"
                              style={{ color: "red" }}
                            ></i>
                          ) : (
                            <i class="fa-regular fa-face-frown"></i>
                          )}
                          <p
                            style={{
                              position: "absolute",
                              marginLeft: "15px",
                              marginTop: "-5px",
                              fontSize: "10px",
                            }}
                          >
                            {isBadTotal}
                          </p>
                        </div>
                      </div>
                      <span
                        className="
                          absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                          hidden group-hover:flex
                          items-center justify-center
                          bg-[#365561] text-white text-sm px-3 py-1 rounded
                          whitespace-nowrap z-10
                        "
                      >
                        Team Assessments
                        <span
                          className="
                            absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                            w-2 h-2 bg-[#365561] rotate-45
                          "
                        />
                      </span>
                    </button>
                    {isCallRequested ? (
                      <button
                        className="
                          group relative cursor-pointer focus:outline-none
                          px-2 py-0.5 rounded-lg
                          bg-gray-50 font-medium
                          border border-gray-300
                          hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                          hover:!border-[#365561]
                        "
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentSlide(index);
                          removeRequestForCall();
                          clickingOnProfile(data.expertID, 'Client canceled call request');
                        }}
                      >
                        <i class="fa-solid fa-phone-slash"></i>
                        <span
                          className="
                            absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                            hidden group-hover:flex
                            items-center justify-center
                            bg-[#365561] text-white text-sm px-3 py-1 rounded
                            whitespace-nowrap z-10
                          "
                        >
                          Cancel Request
                          <span
                            className="
                              absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                              w-2 h-2 bg-[#365561] rotate-45
                            "
                          />
                        </span>
                      </button>
                    ) : (
                      <button
                        className="
                          group relative cursor-pointer focus:outline-none
                          px-2 py-0.5 rounded-lg
                          bg-gray-50 font-medium
                          border border-gray-300
                          hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                          hover:!border-[#365561]
                        "
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentSlide(index);
                          setIsExpertCalendarOpen(true);
                          clickingOnProfile(data.expertID, 'Client opened calender to request a call');
                        }}
                      >
                        <i class="fa-solid fa-phone"></i>
                        <span
                          className="
                            absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                            hidden group-hover:flex
                            items-center justify-center
                            bg-[#365561] text-white text-sm px-3 py-1 rounded
                            whitespace-nowrap z-10
                          "
                        >
                          Request Call
                          <span
                            className="
                              absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                              w-2 h-2 bg-[#365561] rotate-45
                            "
                          />
                        </span>
                      </button>
                    )}
                    {isAccepted ? (
                      <button
                        className="
                          group relative cursor-pointer focus:outline-none
                          px-2 py-0.5 rounded-lg
                          bg-gray-50 font-medium
                          border border-gray-300
                          hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                          hover:!border-[#365561]
                        "
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentSlide(index);
                          unselectConsultant();
                          clickingOnProfile(data.expertID, 'Client unselected a profile');
                        }}
                      >
                        <i class="fa-solid fa-user-minus"></i>
                        <span
                          className="
                            absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                            hidden group-hover:flex
                            items-center justify-center
                            bg-[#365561] text-white text-sm px-3 py-1 rounded
                            whitespace-nowrap z-10
                          "
                        >
                          Unselect
                          <span
                            className="
                              absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                              w-2 h-2 bg-[#365561] rotate-45
                            "
                          />
                        </span>
                      </button>
                    ) : (
                      <button
                        className="
                          group relative cursor-pointer focus:outline-none
                          px-2 py-0.5 rounded-lg
                          bg-gray-50 font-medium
                          border border-gray-300
                          hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                          hover:!border-[#365561]
                        "
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentSlide(index);
                          selectConsultantForCall();
                          clickingOnProfile(data.expertID, 'Client selected a profile');
                        }}
                      >
                        <i class="fa-solid fa-user-plus"></i>
                        <span
                          className="
                            absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                            hidden group-hover:flex
                            items-center justify-center
                            bg-[#365561] text-white text-sm px-3 py-1 rounded
                            whitespace-nowrap z-10
                          "
                        >
                          Select
                          <span
                            className="
                              absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                              w-2 h-2 bg-[#365561] rotate-45
                            "
                          />
                        </span>
                      </button>
                    )}
                    <button
                      className="
                        group relative cursor-pointer focus:outline-none
                        px-2 py-0.5 rounded-lg
                        bg-gray-50 font-medium
                        border border-gray-300
                        hover:bg-[#365561] hover:text-white hover:shadow-[0_0_10px_#365561]
                        hover:!border-[#365561]
                      "
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDecline(true);
                        setCurrentSlide(index);
                        clickingOnProfile(data.expertID, 'Client clicked on decline profile');
                      }}
                    >
                      <i class="fa-solid fa-ban"></i>
                      <span
                        className="
                          absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                          hidden group-hover:flex
                          items-center justify-center
                          bg-[#365561] text-white text-sm px-3 py-1 rounded
                          whitespace-nowrap z-10
                        "
                      >
                        Decline
                        <span
                          className="
                            absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                            w-2 h-2 bg-[#365561] rotate-45
                          "
                        />
                      </span>
                    </button>
                  </>
                ) : (
                  <button
                    className="
                      group relative cursor-pointer focus:outline-none
                      px-2 py-0.5 rounded-lg
                    "
                    onClick={(e) => {
                      e.stopPropagation();
                      addToExistingLink();
                      clickingOnProfile(data.expertID, 'Client clicked on reactivate profile');
                    }}
                  >
                    <i class="fa-solid fa-ban text-[20px] text-red-500"></i>
                    <span
                      className="
                        absolute left-1/2 -translate-x-1/2 bottom-full mb-2
                        hidden group-hover:flex
                        items-center justify-center
                        bg-[#365561] text-white text-sm px-3 py-1 rounded
                        whitespace-nowrap z-10
                      "
                    >
                      Reactivate?
                      <span
                        className="
                          absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2
                          w-2 h-2 bg-[#365561] rotate-45
                        "
                      />
                    </span>
                  </button>
                )}
              </div>
            </div>
            <div className="mt-1 md:-mt-[8px]">
              <div className="grid min-w-0 grid-cols-1 gap-3 md:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)] md:gap-4">
                <div className="min-w-0">
                  <div className="mb-3 flex items-stretch gap-3 md:hidden">
                    <img
                      src={profilePictureUrl}
                      alt=""
                      className={[
                        useEmbeddedWizardMode ? "w-12" : "w-16",
                        "self-stretch shrink-0 rounded-2xl bg-[#365561] shadow-sm object-cover",
                      ].join(" ")}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = fallbackProfilePicture;
                      }}
                    />

                    <div className="min-w-0 flex-1 self-center">
                      <div className="share-profile-status-pills flex min-w-0 flex-wrap items-center gap-1.5">
                        {data.hasName ? (
                          <p className="min-w-0 truncate text-[14px] font-semibold leading-5 text-slate-900">
                            {projectType === "exp" ? "EPH_EXP_" : "EPH_CON_"}
                            {data.expertDigitalID} ({data.expertName})
                          </p>
                        ) : (
                          <p className="min-w-0 truncate text-[14px] font-semibold leading-5 text-slate-900">
                            {projectType === "exp" ? "EPH_EXP_" : "EPH_CON_"}
                            {data.expertDigitalID}
                          </p>
                        )}

                        {isCallConducted ? (
                          <>
                            <button type="button" className="status-pill-conducted" onClick={(e) => e.stopPropagation()}>
                              Call conducted
                            </button>
                            <button
                              type="button"
                              className="status-pill-follow-up"
                              onClick={(e) => {
                                e.stopPropagation();
                                setCurrentSlide(index);
                                setIsExpertCalendarOpen(true);
                                clickingOnProfile(data.expertID, 'Client clicked on follow-up call');
                              }}
                            >
                              Follow-up?
                            </button>
                          </>
                        ) : isCallScheduled ? (
                          <button
                            type="button"
                            className="group relative status-pill-scheduled"
                            onClick={(e) => {
                              e.stopPropagation();
                              setCurrentSlide(index);
                              setViewCallDetails(true);
                              clickingOnProfile(data.expertID, 'Client viewed Teams call joining details');
                            }}
                          >
                            Call scheduled
                            <span
                              className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:flex items-center justify-center rounded bg-[#365561] px-3 py-1 text-sm font-medium text-white shadow-lg whitespace-nowrap"
                            >
                              View Joining Details
                              <span className="absolute bottom-0 left-1/2 h-2 w-2 -translate-x-1/2 translate-y-1/2 rotate-45 bg-[#365561]" />
                            </span>
                          </button>
                        ) : isCallRequested ? (
                          <button type="button" className="status-pill-requested" onClick={(e) => e.stopPropagation()}>
                            Call requested
                          </button>
                        ) : (
                          isAccepted && (
                            <button type="button" className="status-pill-shortlisted" onClick={(e) => e.stopPropagation()}>
                              Shortlisted
                            </button>
                          )
                        )}
                      </div>

                      <p className="share-profile-position-one-line mt-0.5 text-xs leading-5 text-slate-500">
                        {data.expertPosition}
                      </p>

                      <div className="mt-1 space-y-0.5 text-[11px] font-medium leading-4 text-slate-500">
                        {data.expertLocation && (
                          <p className="truncate">
                            <i className="fa-solid fa-map-location-dot mr-1 text-slate-400"></i>
                            {data.expertLocation}
                          </p>
                        )}

                        {data.expertDailyRate && (
                          <p className="truncate text-[#365561]">
                            <i className="fa-solid fa-money-bill-1-wave mr-1"></i>
                            {data.projectCurrency} {data.expertDailyRate}{" "}
                            {data.expertBillingFrequency}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className="hidden text-[14px] text-gray-500 md:[display:-webkit-box]"
                    style={{
                      WebkitLineClamp: "1",
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      width: "90%",
                    }}
                  >
                    {data.expertPosition}
                  </div>
                  <div className="hidden text-[14px] text-gray-500 md:block">
                    <p>
                      <i class="fa-solid fa-map-location-dot"></i>{" "}
                      {data.expertLocation}
                    </p>
                    <p style={{ marginTop: "-4px" }}>
                      <i class="fa-solid fa-money-bill-1-wave"></i>{" "}
                      {data.projectCurrency} {data.expertDailyRate}{" "}
                      {data.expertBillingFrequency}
                    </p>
                  </div>
                  <p className="text-[14px] text-gray-500 font-semibold">
                    Experience
                  </p>
                  <div
                    className={["share-profile-rich-experience w-full text-gray-500 md:w-[98%] md:text-[14px]", mobileTextClass].join(" ")}
                  >
                    {experienceLines.map((line, lineIndex) => (
                      <p
                        key={`${data.expertID || index}-experience-${lineIndex}`}
                        className="share-profile-experience-line"
                        dangerouslySetInnerHTML={{ __html: line }}
                      />
                    ))}
                  </div>
                </div>
                <div
                  className="flex-item-shere-profile-item-profile-info-containter-item-details-container-item-education min-w-0"
                >
                  <p className="text-[14px] text-gray-500 font-semibold">
                    Summary
                  </p>
                  <div
                    className={["share-profile-rich-summary w-full text-gray-500 md:w-[98%] md:text-[14px]", mobileTextClass].join(" ")}
                    contentEditable="true"
                    dangerouslySetInnerHTML={{ __html: data.expertSum }}
                  ></div>

                  <div
                    className={[
                      "pointer-events-none hidden md:block absolute bottom-0 right-0 z-30",
                      "h-8 w-[250px] items-center justify-end",
                      "pr-3 text-[13px] font-semibold text-white",
                      "overflow-hidden rounded-br-xl",
                      "transition-opacity duration-200",
                      hoveringIndex === index ? "flex opacity-100" : "hidden opacity-0",
                    ].join(" ")}
                  >
                    <svg
                      className="absolute inset-0 h-full w-full"
                      viewBox="0 0 150 36"
                      preserveAspectRatio="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M150 0 L150 36 L0 36 C42 32 64 22 82 12 C101 2 122 0 150 0 Z"
                        fill="#365561"
                      />
                    </svg>

                    <span className="relative top-[11px] left-[125px] z-10 whitespace-nowrap">
                      Click to view more!
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showDecline && (
        <DeclineProfile
          projectID={proj_id}
          profile={data}
          setShowDecline={setShowDecline}
          setIsAccepted={setIsAccepted}
          setIsDeclined={setIsDeclined}
          clickingOnProfile={clickingOnProfile}
        />
      )}
      {openAssessment && (
        <Assessments
          projectID={proj_id}
          profile={data}
          setOpenAssessment={setOpenAssessment}
          clientAssessmentRefresh={getClientAssessment}
          clickingOnProfile={clickingOnProfile}
        />
      )}
      {isViewTranscript && (
        <MeetingTranscript
          transcripts={transcripts}
          expertID={expert_id}
          onClose={() => setIsViewTranscript(false)}
          clickingOnProfile={clickingOnProfile}
        />
      )}
      {isMeetingVideo && (
        <MeetingVideo 
          projectID={proj_id}
          expertID={expert_id}
          onClose={setIsMeetingVideo}
          clickingOnProfile={clickingOnProfile}
        />
      )}
      {isExpertCalendarOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <CallRequest
            callingFrom={'client'}
            projectID={proj_id}
            expertID={data.expertID}
            profilesList={profilesList}
            projectType={projectType}
            setOpenCall={setIsExpertCalendarOpen}
            setIsCallRequested={setIsCallRequested}
            markProfilesAsCallRequested={markProfilesAsCallRequested}
            embeddedWizardMode={useEmbeddedWizardMode}
            embeddedWizeredMode={useEmbeddedWizardMode}
            clickingOnProfile={clickingOnProfile}
          />
        </div>
      )}
      {viewCallDetails && (
        <CallDetails
          projectID={proj_id}
          expertID={data.expertID}
          setIsViewEventDetails={setViewCallDetails}
          clickingOnProfile={clickingOnProfile}
        />
      )}
    </>
  );
}